import { Button, Grid } from '@medely/web-components';
import { TextField } from '@medely/web-components/forms';
import { composeValidation, email, required } from 'core/utils/validation';
import { Form } from 'react-final-form';
import React from 'react';
import useResetPassword from './useResetPassword';

const emailValidator = composeValidation(required, email);

const RequestResetPasswordForm = (): React.ReactElement => {
  const resetPassword = useResetPassword();
  return (
    <Form initialValues={{}} onSubmit={resetPassword}>
      {({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid data-testid="login-reset-password-input" item xs={12}>
              <TextField
                name="account[email]"
                label="Email"
                placeholder="Email"
                validate={emailValidator}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                data-testid="login-reset-password-button"
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                disabled={submitting}
              >
                {submitting ? 'Please, wait...' : 'Reset Password'}
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Form>
  );
};

export default RequestResetPasswordForm;
